formatStartDateOverride